import Vue from 'vue'
import { ProductState } from '@/product/types'
import { scrollToElement } from '@/helper'
import { addProductToCart } from '@/common/service'
import { SYSTEM_ERROR } from '@/common/constants'
import LocalStorageSerializer from '@/common/localStorageSerializer'
import { LOCAL_STORAGE_KEY } from '@/product/const'
import { BQ_EVENT_NAMES } from '@/common/utils/eventTracker'

export default Vue.extend({
  data(): {
    isProcessing: boolean
  } {
    return {
      isProcessing: false
    }
  },
  computed: {
    $_storeState(): ProductState {
      return this.$store.state
    },
    $_disableButton(): boolean {
      return (
        this.isProcessing ||
        this.$store.getters.isProductUnpublished ||
        !this.$store.getters.isSimplifiedSendable
      )
    },
    invalidActionProcess(): boolean {
      return (
        !this.$store.getters.validQuantity ||
        this.$store.getters.invalidProductSetSelection
      )
    }
  },
  methods: {
    async $_cartNow() {
      const payload = {
        eventName: BQ_EVENT_NAMES.CART_NOW,
        data: {
          productId: this.$_storeState.productDetail.product.id,
          quantity: this.$_storeState.estimate.quantity
        }
      }
      // @ts-ignore
      if (window.raksulDataCollector) {
        try {
          // @ts-ignore
          await window.raksulDataCollector.sendEvent(payload.eventName, payload.data)
        } catch (error) {
          console.log(error)
        }
      }
      this.$_addToCart(false, true)
    },
    async $_addToCart(validateSizeInput = true, validateAddon = true) {
      if (this.invalidActionProcess) {
        if (validateSizeInput) this.$store.dispatch('showSizeInputWarning')
        if (validateAddon) this.$store.dispatch('showAddonWarning')
        this.$store.dispatch('trackingError', 'Cart')
        this.$nextTick(() => scrollToElement('[class*="pr-InvalidOrderProcess"]'))
      } else {
        this.isProcessing = true
        const data = await addProductToCart({
          printableSkuId: this.$_storeState.productDetail.printableSkuId,
          addonPrintableSkuId: this.$store.getters.addonProductPsi,
          sizes: this.$_storeState.sizeInput,
          recart: false,
          submissionUuids: [],
          skuPrintableSpecialColorIds: [],
          skuPrintableCmykColorIds: [],
          saveDesignToLibrary: false,
          prefectureId:
            LocalStorageSerializer.get(
              LOCAL_STORAGE_KEY.PRODUCT_DETAIL_PREFECTURE
            )?.id || null,
          designVersionUuid:
            this.$_storeState.stockLibraryDesign.userDesignVersionUuid || null,
          plainGoodByUser:
            !this.$_storeState.isPrintingSelected &&
            this.$store.getters.isColorPatternPlainSelected,
          optionIds: this.$_storeState.selectedAdditionalOptionIds
        }).catch(() => {
          alert(SYSTEM_ERROR.UNKNOWN)
        }).finally(() => {
          this.isProcessing = false
        })
        if (data) {
          location.href = '/cart'
        }
      }
    }
  }
})
